// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fdvo","label":"styles_label__2pN2V"};